export const manageStatusesDtoToModel = ({
  statusTarget: { id, name, description },
  needReason,
  needReasonType,
  statusReasons,
}) => ({
  id,
  name,
  description,
  needReason,
  needReasonType,
  reasonTypes: statusReasons,
});

export const modelToPayload = ({ currentStatusTargetId, model }) => ({
  statusId: currentStatusTargetId,
  // return and disapproval
  reason: model?.reason ?? null,
  statusReasons:
    model?.reasonTypes?.map((x) => ({
      statusReasonTypeId: x.id,
    })) ?? [],
  // approval
  academicYearId: model?.academicYear?.id ?? null,
  determinationId: model?.determination?.id ?? null,
});
